import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '../../pages/landing';
import CpanelLoginPage from '../../pages/cpanel/login';
import CpanelSsoPage from '../../pages/cpanel/sso';
import ErrorPage from '../../pages/error';
import CpanelRoutes from './cpanel';
import HospitalRoutes from './hospital';
import { CpanelGuestGuard } from './guards/cpanelAuth';

const RoutesConfig = () => (
  <Router>
    <Routes>
      <Route path="/cpanel/sso" element={<CpanelSsoPage />} />
      <Route element={<CpanelGuestGuard />}>
        <Route path="/cpanel" element={<CpanelLoginPage />} />
      </Route>
      <Route path="/" element={<LandingPage />} />
      <Route path="/welcome" element={<ErrorPage />} />
      <Route path="/cpanel/*" element={<CpanelRoutes />} />
      <Route path="/hospitals/:slugId/*" element={<HospitalRoutes />} />
      <Route path="*" element={<Navigate to="/cpanel" replace />} />
    </Routes>
  </Router>
);

export default RoutesConfig;
